var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealthMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FF576D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5878 9.34095L12 9.94132L12.4122 9.34095C12.9719 8.52577 13.891 8 14.925 8C16.6114 8 18 9.40576 18 11.1667C18 12.0639 17.6385 12.8711 17.0594 13.4462L17.0542 13.4514L17.0491 13.4567L12.7249 18.0104C12.3307 18.4256 11.6691 18.4257 11.2748 18.0106L6.86086 13.364C6.86045 13.3636 6.86005 13.3632 6.85965 13.3627C6.32803 12.7942 6 12.0213 6 11.1667C6 9.40576 7.38858 8 9.075 8C10.1091 8 11.0281 8.52576 11.5878 9.34095Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.5H9.5L10.5 11.25L12 14.75L13.25 12.25L14 13.5H19",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthMarker);
export default __webpack_public_path__ + "static/media/health-marker.48c620beb2fa0bd4b4f568497f441588.svg";
export { ForwardRef as ReactComponent };